import {DecorationMethod} from '~/constants/ProductConstants';
import {getInkMatchCount} from '~/selectors/DesignSelectors';
import {STYLE_TYPE} from '~/constants/ProductConstants';

export const getInkMatchError = (style, state) => {
  const deco = style?.decoration_method;
  const hasInkMatches = getInkMatchCount(state) > 0;
  const notScreenPrint = deco !== DecorationMethod.ScreenPrint;
  const notApparel = style?.style_type !== STYLE_TYPE.APPAREL;

  return (notScreenPrint || notApparel) && hasInkMatches;
};
